import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgUser = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
				<path d="M35 36.6673H5C5 36.6673 7.5 23.334 20 23.334C32.5 23.334 35 36.6673 35 36.6673Z" fill="#4A4A4A" />
				<path
					d="M20.002 32.5007C20.002 32.5007 32.5005 23.334 20.0005 23.334C7.50055 23.334 20.002 32.5007 20.002 32.5007Z"
					fill="white"
				/>
				<path
					d="M20.002 32.5007C20.002 32.5007 32.5005 23.334 20.0005 23.334C7.50055 23.334 20.002 32.5007 20.002 32.5007Z"
					fill="url(#paint0_linear_18214_19427)"
				/>
				<circle cx="20.0013" cy="13.1204" r="8.33333" fill="url(#paint1_linear_18214_19427)" />
				<defs>
					<linearGradient
						id="paint0_linear_18214_19427"
						x1="26.3894"
						y1="33.334"
						x2="14.4453"
						y2="33.334"
						gradientUnits="userSpaceOnUse">
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
					<linearGradient
						id="paint1_linear_18214_19427"
						x1="20.0013"
						y1="4.78711"
						x2="20.8346"
						y2="34.167"
						gradientUnits="userSpaceOnUse">
						<stop stopColor="#E4EDFC" />
						<stop offset="1" stopColor="#568DFE" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
